import { fetchFavoriteProducts } from 'actions/products';
import { trackUserInteraction } from 'actions/tracking';
import { CustomOfferItemPreviewV2, Icon, Loader } from 'components';
import * as t from 'data';
import { formatPrice } from 'helpers';
import { useDispatch, useHistory, useSelector } from 'hooks';
import { isEmpty } from 'lodash';
import { useToast } from 'mymoria-ui/hooks';
import React, { FunctionComponent, useEffect, useState, useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import { isOfferEditable } from 'reducers/proposal';
import FavoriteProductsCard from '../FavoriteProductsCard';

const BasicProductPreview: FunctionComponent<{ id: string }> = ({ id }) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const { addToast } = useToast();
  const { url } = useRouteMatch();
  const { push } = useHistory();
  const isEditable = useSelector(isOfferEditable());
  const selectedProduct = useSelector(({ entities }) => entities.products[id]);
  const funeralType = useSelector(({ proposal }) => proposal.funeralType);
  const salesforce = useSelector(({ proposal }) => proposal.salesforce);
  const favoriteProducts = useSelector(({ products }) => products.favorite);

  const handleEdit = () => {
    dispatch(trackUserInteraction('Edit Product', selectedProduct.translations.shortname));
    push(`${url}/products/${selectedProduct.category}`);
  };

  const favoriteProductsIds = useMemo(
    () =>
      selectedProduct?.category && !isEmpty(favoriteProducts)
        ? favoriteProducts[funeralType][selectedProduct?.category]
        : [],
    [selectedProduct?.category, favoriteProducts, funeralType],
  );

  useEffect(() => {
    if (funeralType && selectedProduct?.category && isEmpty(favoriteProductsIds)) {
      setIsLoading(true);
      dispatch(
        fetchFavoriteProducts({
          category: selectedProduct?.category,
          isFavorite: true,
          pricebookId: salesforce?.pricebookId,
          type: funeralType,
        }),
      ).finally(() => setIsLoading(false));
    }
  }, [
    dispatch,
    setIsLoading,
    salesforce?.pricebookId,
    selectedProduct?.category,
    favoriteProductsIds,
    addToast,
    funeralType,
  ]);

  if (!selectedProduct) {
    return null;
  }

  return (
    <>
      <CustomOfferItemPreviewV2
        id={id}
        key={id}
        selected={isEditable}
        isEditable={isEditable}
        name={selectedProduct.translations.shortname}
        price={selectedProduct.price}
        priceFormatter={formatPrice}
        image={selectedProduct.pictures[0] || selectedProduct.placeholder}
        onClick={isEditable ? handleEdit : undefined}
        description={selectedProduct.translations.description}
        quantity={selectedProduct.quantity}
        actionLabel={t.global.labels.edit}
        actionIcon={<Icon.Pencil />}
      />

      {!isLoading ? (
        favoriteProductsIds &&
        !isEmpty(favoriteProductsIds) && (
          <FavoriteProductsCard
            selectedItemsIds={[selectedProduct.id]}
            category={selectedProduct.category}
            favoriteProductsIds={favoriteProductsIds}
            selectedItem={selectedProduct}
          />
        )
      ) : (
        <Loader />
      )}
    </>
  );
};

export default BasicProductPreview;
